<div class="p-0">
  <div class="mt-5 container-fluid">
    <form #form class="container d-flex justify-content-between g-3 needs-validation" novalidate>
      <div class="col-fluid">
        <input type="text" class="form-control" placeholder="Username" aria-label="Username" aria-describedby="basic-addon">
      </div>
      <div class="col-fluid">
        <button class="btn btn-primary" type="button" (click)="onSubmit()">{{submitted ? 'Unsubscribed' : 'Unsubscribe'}}</button>
      </div>
    </form>
  </div>
</div>
